.media-default-skin .media-button-group {
  display: flex;
  gap: 1px;
  align-items: center;

  &:dir(rtl) {
    flex-direction: row-reverse;
  }
}
